(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8219],{

/***/ 26800:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vpnpricecomparison",
      function () {
        return __webpack_require__(86041);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 86041:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ vpnpricecomparison; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./src/lib/vpnpricecomparison/usageReasons.ts
const reasons = [
    {
        image: "/vpnpricecomparison/assets/images/connect.png",
        title: "Be wherever you want to be",
        description: "Access servers spanning nearly 100 countries worldwide and hide your true location from online services."
    },
    {
        image: "/vpnpricecomparison/assets/images/access.png",
        title: "Access everything",
        description: "Empower your digital experience with VPNs. Seamlessly access content from around the globe and enjoy the freedom to browse, stream, and download without borders."
    },
    {
        image: "/vpnpricecomparison/assets/images/anonymous.png",
        title: "Enjoy true online anonymity",
        description: "Surf the web and download files without the fear of being traced or monitored. Your anonymity is guaranteed With top-tier VPNs."
    }, 
];

// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./src/components/vpnpricecomparison/usageReasons/index.tsx




function UsageReasons() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "mb-14 max-w-xl md:max-w-3xl lg:max-w-7xl mx-auto md:text-center lg:text-left",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: "text-xl md:text-2xl font-bold mb-5",
                children: "Why use VPN Services"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "lg:flex lg:justify-between lg:children:px-3 lg:children:first:pr-6 lg:children:first:pl-0 lg:children:last:pl-6 lg:children:last:pr-0",
                children: reasons.map((reason, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mb-10 lg:w-1/3 md:max-w-xl md:mx-auto",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-fill",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    layout: "intrinsic",
                                    src: reason.image,
                                    alt: reason.title,
                                    width: 392,
                                    height: 190
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "mt-3 font-medium text-lg",
                                children: reason.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-sm mt-1 font-light",
                                children: reason.description
                            })
                        ]
                    }, index))
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/components/vpnpricecomparison/mainSection/index.tsx + 1 modules
var mainSection = __webpack_require__(80859);
// EXTERNAL MODULE: ./src/components/layouts/index.tsx + 2 modules
var layouts = __webpack_require__(30171);
;// CONCATENATED MODULE: ./pages/vpnpricecomparison/index.tsx






const DefaultOffers = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(3294), __webpack_require__.e(82546), __webpack_require__.e(20513)]).then(__webpack_require__.bind(__webpack_require__, 20513)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(20513)
            ]
    }
});
const WeStand = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(3294), __webpack_require__.e(82546), __webpack_require__.e(73446)]).then(__webpack_require__.bind(__webpack_require__, 73446)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(73446)
            ]
    }
});
const Home = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(layouts/* VpnPriceComparisonWrapper */.S, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(mainSection/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(UsageReasons, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DefaultOffers, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(WeStand, {})
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var vpnpricecomparison = (Home);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [30171,74520,49774,92888,40179], function() { return __webpack_exec__(26800); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);